/**
 * Hook para listar FAQs / ayuda.
 */
import type { Faq } from "common/models";
import { useQuery } from "react-query";
import { Queries } from "ui/query/queries";
import { faqsApi } from "../api/faqsApi";

export function useHelpFindAll() {
    return useQuery<Faq[]>([Queries.HELP_FIND_ALL], () => faqsApi.findAll());
}
